module.exports = __webpack_public_path__ + "img/paying.d201b634.png";